import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/giz-library/user/service/user.service';

@Component({
  selector: 'app-explorer-view',
  templateUrl: './explorer-view.component.html',
  styleUrls: ['./explorer-view.component.css']
})
export class ExplorerViewComponent implements OnInit {

  constructor(private route: ActivatedRoute, public userService: UserService) { }

  p_variety_name!: string | null;
  p_farmer_name!: string | null;
  p_any_date!: string | null;
  p_date_exactly!: string | null;
  p_date_init!: string | null;
  p_date_end!: string | null;
  p_month!: string | null;
  p_user_id!: string | null;
  p_username!: string | null;
  p_place!: string | null;

  p_country!: string | null;
  p_is_original!: string | null;
  p_is_public!: string | null;

  ngOnInit(): void {

    this.p_variety_name = this.route.snapshot.queryParamMap.get("p_variety_name");
    this.p_farmer_name = this.route.snapshot.queryParamMap.get("p_farmer_name");
    this.p_any_date = this.route.snapshot.queryParamMap.get("p_any_date");
    this.p_date_exactly = this.route.snapshot.queryParamMap.get("p_date_exactly");
    this.p_date_init = this.route.snapshot.queryParamMap.get("p_date_init");
    this.p_date_end = this.route.snapshot.queryParamMap.get("p_date_end");
    this.p_month = this.route.snapshot.queryParamMap.get("p_month");
    this.p_user_id = this.route.snapshot.queryParamMap.get("p_user_id");
    this.p_username = this.route.snapshot.queryParamMap.get("p_username");
    this.p_place = this.route.snapshot.queryParamMap.get("p_place");

    this.p_country = this.route.snapshot.queryParamMap.get("p_country");
    this.p_is_original = this.route.snapshot.queryParamMap.get("p_is_original");
    this.p_is_public = this.route.snapshot.queryParamMap.get("p_is_public");

    document.getElementsByClassName("head")[0].scrollIntoView();
  }

}

